export const themesC = {
    dark: '#060606',
    white: '#f0ede5',
    cream: '#c9af7f',
    grey: '#747474',
    grey_Ligth_100: '#f3f3f3',
    grey_Ligth: '#9c9c9c',
    grey_Dark: '#444444'
    
}

export const size = {
    mobile: '320px',
    tablet: '450px',
    desktop: '700px',
}
